import React from "react";
import PropTypes from "prop-types";
import alertIcon from "./alertIcon.svg";
import calendarIcon from './calendarIcon.svg';
import cancelIcon from "./cancelIcon.svg";
import centerIcon from "./centerIcon.svg";
import checkIcon from "./checkIcon.svg";
import checkFilledIcon from "./checkFilledIcon.svg";
import checkboxIcon from "./checkboxIcon.svg";
import chevronRightIcon from './chevronRightIcon.svg';
import uncheckedBoxIcon from "./uncheckedBoxIcon.svg";
import closeIcon from "./closeIcon.svg";
import collapseIcon from "./collapseIcon.svg";
import collectIcon from "./collectIcon.svg";
import compassIcon from "./compassIcon.svg";
import copyIcon from "./copyIcon.svg";
import downCaretIcon from "./downCaretIcon.svg";
import downCaretIconNew from "./downCaretIconNew.svg";
import downRightArrowIcon from "./downRightArrowIcon.svg";
import drawIcon from "./drawIcon.svg";
import editIcon from "./editIcon.svg";
import expandIcon from "./expandIcon.svg";
import fileIcon from "./fileIcon.svg";
import groupIcon from "./groupIcon.svg";
import helpIcon from "./helpIcon.svg";
import infoIcon from "./infoIcon.svg";
import institutionIcon from './institutionIcon.svg';
import leftArrowIcon from "./leftArrowIcon.svg";
import leftArrowSlimIcon from "./leftArrowSlimIcon.svg";
import leftDoubleIcon from "./leftDoubleIcon.svg";
import lineStringIcon from "./lineStringIcon.svg";
import linkIcon from "./linkIcon.svg";
import minusIcon from "./minus.svg";
import overlayIcon from "./overlayIcon.svg";
import opacityIcon from "./opacityIcon.svg";
import plusIcon from "./plus.svg";
import pointIcon from "./pointIcon.svg";
import polygonIcon from "./polygonIcon.svg";
import questionIcon from "./questionIcon.svg";
import radioCheckedIcon from "./radioCheckedIcon.svg";
import radioUncheckedIcon from "./radioUncheckedIcon.svg";
import refreshIcon from "./refreshIcon.svg";
import rightArrowIcon from "./rightArrowIcon.svg";
import rightCaretIcon from "./rightCaretIcon.svg";
import rightDoubleIcon from "./rightDoubleIcon.svg";
import ruleIcon from "./ruleIcon.svg";
import saveIcon from "./saveIcon.svg";
import searchIcon from "./searchIcon.svg";
import settingsIcon from "./settingsIcon.svg";
import trashIcon from "./trashIcon.svg";
import upArrowIcon from "./upArrowIcon.svg";
import upCaretIcon from "./upCaretIcon.svg";
import upCaretIconNew from "./upCaretIconNew.svg";
import zoomInIcon from "./zoomInIcon.svg";
import personIcon from "./personIcon.svg";
import landscapeIcon from "./landscapeIcon.svg";
import mapIcon from './mapIcon.svg';
import folderIcon from './folderIcon.svg';
import morevertIcon from './morevertIcon.svg';

export const iconMap = {
  alert: alertIcon,
  calendar: calendarIcon,
  cancel: cancelIcon,
  center: centerIcon,
  check: checkIcon,
  checkFilled: checkFilledIcon,
  checkboxChecked: checkboxIcon,
  checkboxUnchecked: uncheckedBoxIcon,
  chevronRight: chevronRightIcon,
  close: closeIcon,
  collapse: collapseIcon,
  collect: collectIcon,
  compass: compassIcon,
  copy: copyIcon,
  downCaret: downCaretIcon,
  downCaretNew: downCaretIconNew,
  downRightArrow: downRightArrowIcon,
  draw: drawIcon,
  edit: editIcon,
  expand: expandIcon,
  file: fileIcon,
  group: groupIcon,
  help: helpIcon,
  info: infoIcon,
  institution: institutionIcon,
  leftArrow: leftArrowIcon,
  leftArrowSlim: leftArrowSlimIcon,
  leftDouble: leftDoubleIcon,
  lineString: lineStringIcon,
  link: linkIcon,
  minus: minusIcon,
  opacity: opacityIcon,
  overlay: overlayIcon,
  plus: plusIcon,
  point: pointIcon,
  polygon: polygonIcon,
  question: questionIcon,
  radio: radioUncheckedIcon,
  radioChecked: radioCheckedIcon,
  refresh: refreshIcon,
  rightArrow: rightArrowIcon,  
  rightCaret: rightCaretIcon,
  rightDouble: rightDoubleIcon,
  rule: ruleIcon,
  save: saveIcon,
  search: searchIcon,
  settings: settingsIcon,
  trash: trashIcon,
  upArrow: upArrowIcon,
  upCaret: upCaretIcon,
  upCaretNew: upCaretIconNew,
  zoomIn: zoomInIcon,
  users: personIcon,
  projects: landscapeIcon,
  imagery: mapIcon,
  folder: folderIcon,
  moreVert: morevertIcon,

};

function SvgIcon({ icon, color, cursor, size, verticalAlign, transform }) {
  const Icon = iconMap[icon];
  return (
    <Icon
      color={color}
      cursor={cursor}
      fill={color}
      height={size}
      style={{ verticalAlign, transform }}
      width={size}
    />
  );
}

SvgIcon.propTypes = {
  color: PropTypes.string,
  cursor: PropTypes.string,
  icon: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  verticalAlign: PropTypes.string,
  transform: PropTypes.string,
};

SvgIcon.defaultProps = {
  color: "currentColor",
  cursor: "unset",
  verticalAlign: "middle",
  transform: "",
};

export default SvgIcon;
